import { render, staticRenderFns } from "./logisticsAgreement.vue?vue&type=template&id=4b5c18aa&scoped=true&"
import script from "./logisticsAgreement.vue?vue&type=script&lang=js&"
export * from "./logisticsAgreement.vue?vue&type=script&lang=js&"
import style0 from "./logisticsAgreement.vue?vue&type=style&index=0&id=4b5c18aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5c18aa",
  null
  
)

component.options.__file = "logisticsAgreement.vue"
export default component.exports